// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicyContainer":"privacy-policy_privacyPolicyContainer__eAjJz"};